<template>
  <div class="steps-component-payment">
    <ul class="steps is-vertical">
      <li
        v-if="tab.isActive"
        class="steps-segment mb-6 is-active"
        v-for="(tab, key) in tabs"
        :key="key"
      >
        <span class="steps-marker">
          <span class="is-size-2"> {{ key+1 }} </span>
        </span>
        <div class="steps-content is-fullwidth pl-6">
          <div class="columns">
            <div class="column is-truncate-text is-12 pl-5">
              <span class="is-size-4 has-text-weight-bold has-text-white is-no-wrap" v-if="tab.name">
                {{ tab.name }}
              </span>
            </div>
          </div>
        </div>
      </li>
      <div class="tab-details mb-6">
        <slot></slot>
      </div>
      <li
        v-if="!tab.isActive"
        class="steps-segment mb-6"
        v-for="(tab, key) in tabs"
        :key="key"
      >
        <span class="steps-marker">
          <span class="is-size-2"> {{ key+1 }} </span>
        </span>
        <div class="steps-content is-fullwidth pl-6">
          <div class="columns">
            <div class="column is-truncate-text is-12 pl-5">
              <span class="is-size-4 has-text-weight-bold has-text-white is-no-wrap" v-if="tab.name">
                {{ tab.name }}
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {

  name: 'steps',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      tabs: [],
      currentActive: 0,
      totalTabs: 0
    }
  },

  created() {
    this.tabs = this.$children
  },

  mounted() {
    this.totalTabs = this.tabs.length
  },

  methods: {
    previousTab() {
      this.currentActive--

      this.tabs.forEach(tab => {
        tab.isActive = false
      })
      this.tabs[this.currentActive].isActive = true
    },

    nextTab(plusPages = 1) {
      //Validate input
      this.$root.$validator.validate('step' + (this.currentActive + plusPages)+'.*').then(valid => {
        if (valid) {
          this.currentActive += plusPages

          this.tabs.forEach(tab => {
            tab.isActive = false
          })

          this.tabs[this.currentActive].isActive = true
        }
      })
    }
  },
  computed: {
    isBlackNovember() {
      return process.env.VUE_APP_IS_BLACK_NOVEMBER
    }
  }

}

</script>

<style lang="scss">

.steps-component-payment {
  $grey: #dae6ec;
  $grey-dark: #707070;
  $grey-darker: #888888;
  $grey-lighter: #e8f6f7;
  //$primary: var(--primary-color);
  $grey-secondary: #A2A2A2;
  $steps-marker-size: 5;
  $steps-default-color: $grey-secondary;

  $navbar-background-color: var(--primary-color);
  $navbar-height: 1.5rem;
  $navbar-item-img-max-height: 1.2rem;
  $progress-border-radius: 0px;
  $box-background-color: #e4fffb;
  $box-color: var(--primary-color);
  $box-radius: 2rem;
  $link: var(--primary-color) !default;
  $black: hsl(0, 0%, 4%) !default;
  $scheme-invert: $black !default;
  $shadow: 8px 0.4em 0.5em -0.3em rgba($scheme-invert, 0.3), 0 0px 0 1px rgba($scheme-invert, 0.02) !default;
  $box-shadow: $shadow;
  $card-shadow: none;
  $card-footer-border-top: none;
  $card-header-shadow: none;
  $card-content-padding: 0 0 16px 32px;
  $input-radius: 0.5rem;
  $input-border-color: $grey-secondary;
  @import '~bulma';
  @import "./../../../../node_modules/bulma-steps-component/bulma-steps.sass";

  .steps-segment {
    &.is-active {
      .steps-content {
        background-color: var(--primary-color);
      }
    }
    
    // Correção para remover o pseudo-elemento ::after indesejado
    &::after {
      display: none !important;
      content: none !important;
    }
  }

  .is-no-wrap {
    white-space: nowrap;
  }

  .is-fullwidth {
    width: 100%!important;
  }

  .steps-marker {
    z-index: 999;
    box-shadow: 10px 3px 18px #00000017;
  }

  .steps-content {
    width: 30%;
    padding-right: calc(0.25rem + 2em);
    margin-top: -4.6rem!important;
    background-color: $grey-secondary;
    border-radius: 1rem;
  }
  
  // Correção adicional para os pseudo-elementos que podem aparecer
  .steps-segment::after,
  .steps-segment::before,
  .steps li::after,
  .steps li::before,
  .steps-segment.is-active::after {
    display: none !important;
    content: none !important;
  }
}
</style>
